import { useSearchPageStore } from "@/stores/SearchPage";
import { type RouteLocationNormalized } from 'vue-router';
import { storeToRefs } from 'pinia';

const SearchPageStore = useSearchPageStore();
const {
	setQuery,
	fetchMoviesResult,
	fetchShowsResult,
	fetchChannelsResult,
	fetchCreditsResult,
	fetchLiveResult,
	clearAllSearchPage
} = SearchPageStore;
const {
	getQuery: prevQuery
} = storeToRefs(SearchPageStore);


export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (!import.meta.client) {
		return;
	}

	if(to.query.value !== prevQuery.value) {
		clearAllSearchPage();

		setQuery(to.query.value as string);

 		void fetchChannelsResult();

		void fetchLiveResult();

 		void fetchMoviesResult();

		void fetchShowsResult();

		void fetchCreditsResult();
	
	} 
});